// src/RequireAuth.js
import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./hooks/AuthProvider";

import Sidenav from "./Components/Sidenav";
import Header from "./Components/Header";
import Spinner from "./Components/Spinner";
import AiVoiceAssistant from "./Components/AiVoiceAssistant";
import { AiVoiceAssistantProvider } from "./context/AiVoiceAssistantContext";
import VoiceAssistant from "./Components/voice-assistant/VoiceAssistant";

import "./App.css";
import CollapseContext from "./hooks/CollapseContext";

function RequireAuth({ minimalLayout = false, children = null }) {
  const { authed, loading, passwordExpired, resetPasswordRequired } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  function handleOpen(childOpen) {
    setOpen(childOpen);
  }

  if (loading && !authed) {
    return (
      <div style={{ width: "100vw", height: "100vh", display: "grid", placeItems: "center" }}>
        <Spinner />
      </div>
    );
  }

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (resetPasswordRequired && location.pathname !== "/reset-password") {
    return <Navigate to="/reset-password" replace />;
  }

  if (!resetPasswordRequired && location.pathname === "/reset-password") {
    return <Navigate to={passwordExpired ? "/force-change-password" : "/devices"} replace />;
  }

  if (passwordExpired && location.pathname !== "/force-change-password") {
    return <Navigate to="/force-change-password" replace />;
  }

  if (minimalLayout) {
    return loading ? (
      <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center" }}>
        <Spinner />
      </div>
    ) : (
      children || <Outlet />
    );
  }

  return (
    <div className="App">
      <Sidenav handleOpen={handleOpen} />
      <div className="remain">
        <CollapseContext.Provider value={open}>
          <AiVoiceAssistantProvider>
            <div className="header">
              <Header />
            </div>

            <div className="window" style={{ position: "relative" }}>
              {loading ? (
                <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center" }}>
                  <Spinner />
                </div>
              ) : (
                children || <Outlet />
              )}
            </div>

            <AiVoiceAssistant />
            <VoiceAssistant />
          </AiVoiceAssistantProvider>
        </CollapseContext.Provider>
      </div>
    </div>
  );
}

export default RequireAuth;
